import React, { useState, useEffect } from "react";
import BotonManualHeader from "../../components/BotonManualHeader";
import {
  Container,
  Card,
  Table,
  Button,
  Row,
  Col,
  Badge,
  Form,
  OverlayTrigger,
  Tooltip,
  Spinner,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FaSearch, FaUserAlt, FaArrowRight, FaIdCard, FaBuilding, FaHardHat } from "react-icons/fa";
import { LuGlasses } from "react-icons/lu";
import getAllProducts from "../../functions/getAllProducts";

function EntregaActivosList({ usuario }) {
  const navigate = useNavigate();
  const [workers, setWorkers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [datosIniciales, setDatosIniciales] = useState(false);

  useEffect(() => {
    cargarTrabajadores();
  }, []);

  const cargarTrabajadores = async () => {
    try {
      setLoading(true);
      const data = await getAllProducts("users", usuario.ruc);
      // Filtrar solo activos y ordenar
      const activos = data.filter(u => u.activo !== false);
      setWorkers(activos);
      setDatosIniciales(true);
    } catch (error) {
      console.error("Error al cargar trabajadores:", error);
    } finally {
      setLoading(false);
    }
  };

  const workersFiltrados = workers.filter((w) => {
    const term = searchTerm.toLowerCase();
    return (
      w.name?.toLowerCase().includes(term) ||
      w.apellidos?.toLowerCase().includes(term) ||
      w.dni?.toString().includes(term) ||
      w.cargo?.toLowerCase().includes(term)
    );
  });

  return (
    <div
      className="min-vh-100 py-4"
      style={{
        background: "#f8f9fa",
      }}
    >
      <Container>
        {/* Header Premium Orange */}
        <Card
          className="shadow-lg border-0 mb-4"
          style={{ borderRadius: "15px", overflow: "hidden" }}
        >
          <Card.Header
            className="text-white py-4 position-relative"
            style={{
              background: "linear-gradient(135deg, #f97316 0%, #ea580c 100%)",
              borderBottom: "4px solid #fdba74",
            }}
          >
            <div className="position-absolute end-0 top-50 translate-middle-y me-4" style={{ zIndex: 10 }}>
              <BotonManualHeader usuario={usuario} />
            </div>
            <div className="d-flex justify-content-between align-items-center px-3">
              <div>
                <h2 className="fw-bold mb-1">
                  <FaUserAlt className="me-3" />
                  Entrega de Activos y Dotación
                </h2>
                <p className="mb-0 opacity-75">
                  Selecciona un colaborador para gestionar su dotación (EPP, Equipos, Herramientas)
                </p>
              </div>
              <div className="text-end d-none d-md-block">
                <Badge bg="light" text="dark" className="p-2 px-3 rounded-pill shadow-sm">
                  <FaHardHat className="me-2 text-warning" />
                  Sincronizado con App Móvil
                </Badge>
              </div>
            </div>
          </Card.Header>

          <Card.Body className="p-4">
            {/* Buscador */}
            <Row className="mb-4">
              <Col md={8} lg={9}>
                <div className="position-relative">
                  <FaSearch
                    className="position-absolute"
                    style={{
                      left: "15px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#94a3b8",
                    }}
                  />
                  <Form.Control
                    type="text"
                    placeholder="Buscar por nombre, DNI o cargo..."
                    className="form-control-lg ps-5 border-2 shadow-sm"
                    style={{ borderRadius: "12px" }}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </Col>
              <Col md={4} lg={3}>
                <Button
                  variant="warning"
                  className="w-100 h-100 fw-bold text-white d-flex align-items-center justify-content-center gap-2 shadow-sm"
                  style={{ borderRadius: "12px", background: "#f97316", border: "none" }}
                  onClick={cargarTrabajadores}
                >
                  <FaSearch /> Refrescar Lista
                </Button>
              </Col>
            </Row>

            {loading && !datosIniciales ? (
              <div className="text-center py-5">
                <Spinner animation="border" variant="warning" size="lg" />
                <p className="mt-3 text-muted">Cargando lista de colaboradores...</p>
              </div>
            ) : (
              <div className="table-responsive rounded-3 shadow-sm border">
                <Table hover className="mb-0">
                  <thead className="bg-light">
                    <tr>
                      <th className="py-3 px-4 text-muted small fw-bold">COLABORADOR</th>
                      <th className="py-3 px-4 text-muted small fw-bold text-center">DNI</th>
                      <th className="py-3 px-4 text-muted small fw-bold">CARGO / AREA</th>
                      <th className="py-3 px-4 text-muted small fw-bold text-center">ACCIONES</th>
                    </tr>
                  </thead>
                  <tbody>
                    {workersFiltrados.length > 0 ? (
                      workersFiltrados.map((worker) => (
                        <tr key={worker.id} className="align-middle">
                          <td className="py-3 px-4">
                            <div className="d-flex align-items-center">
                              <div 
                                className="rounded-circle bg-orange-light d-flex align-items-center justify-content-center me-3"
                                style={{ width: "40px", height: "40px", backgroundColor: "#fff7ed", color: "#f97316" }}
                              >
                                {worker.name?.charAt(0)}{worker.apellidos?.charAt(0)}
                              </div>
                              <div>
                                <div className="fw-bold text-dark">{worker.name} {worker.apellidos}</div>
                                <div className="text-muted small">{worker.email}</div>
                              </div>
                            </div>
                          </td>
                          <td className="py-3 px-4 text-center">
                            <Badge bg="secondary" className="px-2 py-1 fw-normal">
                              {worker.dni}
                            </Badge>
                          </td>
                          <td className="py-3 px-4">
                            <div className="d-flex flex-column">
                              <span className="text-dark small fw-semibold">
                                <FaBuilding className="me-1 text-muted" size={12} /> {worker.cargo || "N/A"}
                              </span>
                              <span className="text-muted xx-small">
                                {worker.cecoNombre || "Sin Centro de Costo"}
                              </span>
                            </div>
                          </td>
                          <td className="py-3 px-4 text-center">
                            <Button
                              variant="outline-warning"
                              size="sm"
                              className="d-flex align-items-center gap-2 mx-auto px-3 border-2 fw-bold"
                              style={{ borderRadius: "8px" }}
                              onClick={() => navigate(`/activos/entrega/${worker.id}`, { state: { usuario: worker } })}
                            >
                              <LuGlasses size={16} />
                              Entregar Activos
                              <FaArrowRight size={12} />
                            </Button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center py-5 text-muted">
                          No se encontraron colaboradores coincidentes.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            )}
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
}

export default EntregaActivosList;
